(function () {
  function renderLeagueModal(context) {
    if (typeof window.LeagueFormComponent !== "function") return null;

    return window.LeagueFormComponent({
      h: context.h,
      initialData: context.initialData || null,
      profiles: context.profiles || [],
      getStateAbbrev: context.getStateAbbrev,
      getStateDisplayName: context.getStateDisplayName,
      isGlobalCustomer: Boolean(context.isGlobalCustomer),
      onClose: context.onClose,
      onSubmit: context.onSubmit,
      saveStatus: context.saveStatus || "",
    });
  }

  window.SharedPreactLeagueModalRenderer = renderLeagueModal;
  // Backward-compatible alias for existing callers.
  window.SharedLeagueModalRenderer = renderLeagueModal;
})();
